import { useTextareaEffects } from 'hooks/useTextareaEffects';
import { useEffect, useState } from 'react';
import GptIcon from 'components/Icons/gpt.svg';
import { NotesIcon } from '../../icons/notes';
import styled, { css } from 'styled-components';
import { useVehicleEditing } from 'context/isAnotherUserEditingContext';

type InputFieldProps = {
  save: (notes: string) => void;
  initialValue?: string;
  icon?: 'default' | 'gpt';
  autoFocus?: boolean;
};

const disabledCss = css`
  opacity: 0.7;
  pointer-events: none;
`;

const NotesWrapper = styled.div`
  outline: 1px solid #999999;
  border-radius: 8px;
  background: #fff;
  padding: 8px;
  display: flex;
  width: 100%;
  align-items: center;
  overflow: hidden;
  ${props => props.disabled && disabledCss}
`;

const IconWrapper = styled.div<{ withAutoMargin?: boolean }>`
  display: flex;
  margin-left: ${props => (props.withAutoMargin ? 'auto' : 0)};
`;

const NotesInput = styled.textarea`
  border: none;
  font-size: 12px;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;

  font-family: Roboto;
  line-height: 16px;
  font-weight: 500;
  color: #000;
  word-wrap: break-word;
  resize: none;
  padding: 0;
`;

export const NotesInputField = ({ initialValue, save, icon = 'default', autoFocus = true }: InputFieldProps) => {
  const [localNotes, setLocalNotes] = useState<string>(initialValue || '');
  const IconComponent = icon === 'default' ? NotesIcon : GptIcon;
  const wrapperStyle = icon === 'gpt' ? { gap: '12px' } : {};

  const { hasAnotherEditor } = useVehicleEditing();

  useEffect(() => {
    setLocalNotes(initialValue || '');
  }, [initialValue]);

  const ref = useTextareaEffects(localNotes, autoFocus);

  // const RightIcon = useMemo(() => {
  //   if (!localNotes && !initialValue) return null;
  //   return localNotes === initialValue ? <NotesSavedCheckmark /> : <SendIcon />;
  // }, [localNotes, initialValue]);

  useEffect(() => {
    if (localNotes === initialValue) return;

    const timeout = setTimeout(() => {
      save(localNotes);
    }, 500);

    return () => clearTimeout(timeout);
  }, [localNotes, initialValue, save]);

  return (
    <NotesWrapper style={wrapperStyle} disabled={hasAnotherEditor}>
      <IconWrapper>
        <IconComponent />
      </IconWrapper>
      <NotesInput
        rows={1}
        // value={initialValue}
        ref={ref}
        value={localNotes}
        onChange={e => setLocalNotes(e.target.value)}
      />
      {/* <IconWrapper onClick={() => save(localNotes)} withAutoMargin>
        {RightIcon}
      </IconWrapper> */}
    </NotesWrapper>
  );
};
